import React from "react";
import { Field } from "./shared";

const Step1Family = ({ family, setFamily }) => {
  const set = (k) => (e) => setFamily({ ...family, [k]: e.target.value });
  return (
    <form className="space-y-5" autoComplete="on" onSubmit={(e) => e.preventDefault()}>
      <h3 className="font-serif-display text-2xl text-stone-800">1. Famille</h3>
      <p className="text-stone-500 text-sm">Ces informations permettront de créer votre compte famille.</p>

      <fieldset className="space-y-3">
        <legend className="text-xs uppercase tracking-widest text-deep-rose font-medium">Responsable</legend>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="Prénom *" name="given-name" autoComplete="given-name" placeholder="Marie" value={family.parentFirstName} onChange={set("parentFirstName")} required data-testid="family-first-name" />
          <Field label="Nom *" name="family-name" autoComplete="family-name" placeholder="Dupont" value={family.parentLastName} onChange={set("parentLastName")} required data-testid="family-last-name" />
          <Field label="Email *" type="email" name="email" autoComplete="email" inputMode="email" placeholder="marie.dupont@email.fr" value={family.email} onChange={set("email")} required data-testid="family-email" />
          <Field label="Téléphone" type="tel" name="tel" autoComplete="tel" inputMode="tel" placeholder="06 12 34 56 78" value={family.phone} onChange={set("phone")} data-testid="family-phone" />
          <Field label="Mot de passe (6+ caractères) *" type="password" name="new-password" autoComplete="new-password" placeholder="Choisissez un mot de passe" value={family.password} onChange={set("password")} required data-testid="family-password" />
        </div>
      </fieldset>

      <fieldset className="space-y-3">
        <legend className="text-xs uppercase tracking-widest text-deep-rose font-medium">Adresse postale</legend>
        <div className="grid grid-cols-1 sm:grid-cols-6 gap-4">
          <div className="sm:col-span-6">
            <Field label="Adresse (n° et rue)" name="street-address" autoComplete="street-address" placeholder="12 rue des Lilas" value={family.address} onChange={set("address")} data-testid="family-address" />
          </div>
          <div className="sm:col-span-2">
            <Field label="Code postal *" name="postal-code" autoComplete="postal-code" inputMode="numeric" pattern="[0-9]{5}" maxLength={5} placeholder="78610" value={family.postalCode} onChange={set("postalCode")} required data-testid="family-postal-code" />
          </div>
          <div className="sm:col-span-4">
            <Field label="Ville *" name="address-level2" autoComplete="address-level2" placeholder="Le Perray-en-Yvelines" value={family.city} onChange={set("city")} required data-testid="family-city" />
          </div>
        </div>
      </fieldset>
    </form>
  );
};

export default Step1Family;
